/* jshint node:true */
'use strict';

var gameStripUtils = require('./utils/gameStripUtils.js');

/**
 * A class to build data for game strips
 *
 * @constructor
 * @param {Object} params
 */
function GameStrip(params) {

    if (!(this instanceof GameStrip)) {
        return new GameStrip(params);
    }
    var event = params.event;
    var competition = event.competitions[0];
    var home = competition.competitors[0] || {};
    var away = competition.competitors[1] || {};

    // Set form on the home and away team objects
    if (home.form) {
        if ('team' in home){
            home.team.form = home.form;
        }
    }

    if (away.form) {
        if ('team' in away){
            away.team.form = away.form;
        }
    }

    this.id = event.id;
    this.sport = params.sport;
    this.league = event.leagues && event.leagues[0];
    this.date = event.date || competition.date;
    this.formattedDate = gameStripUtils.getFormattedDate(this.date);
    this.gameStatus = gameStripUtils.getGameStatus(competition.status.type.state);

    // This logic accomodates anomalies in rugby/soccer data
    // TODO: Cleanup after it gets fixed
    if(this.gameStatus == 'pregame'){
        this.time = gameStripUtils.getLocalTime(this.date);
    }else{
        this.time = gameStripUtils.getActiveGameStatus(this.gameStatus, competition.status, competition.timeValid);
    }

    var rugbyDetails = [];
    if ('details' in competition) {
        rugbyDetails = competition.details;
        if(rugbyDetails === null){
            rugbyDetails = [];
        }
    }

    // Lookup data formatter function based on sports
    var sportSettings = {
        'soccer' : {
            formatter : 'getGameDetails',
            args : [competition.details, home.id]
        },
        'rugby' : {
            formatter : 'getRugbyDetails',
            args: [rugbyDetails, home.id]
        }
    };
    // Get formatter function and arguments for a sport
    var settings = sportSettings[this.sport];
    var formatter = settings.formatter;
    var args = settings.args;

    //console.info('formatter', formatter);
    // Extract data from utility functions
    this.teams = gameStripUtils.getTeamsInfo(home.team, away.team);
    this.scores = gameStripUtils.getScores(home, away);
    this.winnerClass = gameStripUtils.getWinnerClass(home, away);
    this.gameDetails = gameStripUtils[formatter](args[0], args[1]);
    this.venue = gameStripUtils.getVenueDetails(competition);
    this.broadcasts = gameStripUtils.getBroadcasts(competition.broadcasts);
    this.gameLinks = event.links;
    this.footer = gameStripUtils.getGameNotes(competition, home, away);
    this.heading = gameStripUtils.getHeading(event);
	
	/* itterate game links and correct match this is a HACK for now*/
	var editionsHost = window ? window.location.hostname : 'www.espn.co.uk';
	this.gameLinks.map(function(link, j){
		if(link.text === 'Match' || link.text === 'Report' || link.text === 'Preview'){
			link.href = link.href.replace('www.espn.co.uk',editionsHost);
		}
	});
	
    return this;
}

module.exports = GameStrip;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/GameStrip.js
 **/